import { render, staticRenderFns } from "./contrast.vue?vue&type=template&id=6dcfc6d0&scoped=true&"
import script from "./contrast.vue?vue&type=script&lang=js&"
export * from "./contrast.vue?vue&type=script&lang=js&"
import style0 from "./contrast.vue?vue&type=style&index=0&id=6dcfc6d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcfc6d0",
  null
  
)

export default component.exports